import { Component, OnInit } from "@angular/core";
import { FormGroup, FormArray, Validators } from "@angular/forms";
import { MatRadioChange } from "@angular/material/radio";
import { MemberappBaseComponent } from "../memberapp-base/memberapp-base.component";
import {
	ChapterDetails,
	ChapterInfo
} from "../../../shared/models/chapter-details";
import { NotificationStatus } from "src/app/shared/enums/data.enums";

@Component({
	selector: "app-chapters",
	templateUrl: "./chapters.component.html",
	styleUrls: ["./chapters.component.scss"]
})
export class ChaptersComponent extends MemberappBaseComponent {
	chapterDetails: ChapterDetails;
	chapterForm: FormGroup;
	isGraduatingResident: boolean = false;

	get chapterFormArray(): FormArray {
		return this.chapterForm.get("chapters") as FormArray;
	}

	ngOnInit() {
		//this.loggerService.logInfo(this.memberAppDataService.memberAppData);
		this.isGraduatingResident = this.memberAppDataService.CheckIfEligibleForRegYR123();
		//reset
		this.resetForm();

		//subscriptions
	}

	resetForm() {
		this.chapterDetails = this.chaptersService.getCurrentChapters();
		//this.chaptersService.giveSomeTestData();

		//if RegYR123, only one chapter is allowed which is also set as primary. no secondary chapters are allowed
		//MB 8/2/2024
		if (this.isGraduatingResident) {
			this.chapterDetails.chapters.forEach(a => { a.selected = a.isPrimary });
		}

		this.chapterForm = this.fb.group({
			chapters: this.fb.array(
				this.chapterDetails.chapters.map(a => this.createItem(a))
			)
		});

		this._setPrimary();
	}

	createItem(ci: ChapterInfo): FormGroup {
		return this.fb.group({
			id: ci.id,
			name: ci.name,
			code: ci.code,
			selected: [ci.selected],
			isPrimary: [ci.isPrimary, Validators.required]
		});
	}

	onChapterChangeEvent(event: any, id: any) {
		//For Graduating Residents, We are not allowing secondary chapter selections,
		//so the selected chapter has to be set as Primary - MB 3/15/2024
		if (this.isGraduatingResident) {
			//first uncheck everything
			this.chapterFormArray.controls.forEach(a => a.get("selected")
				.setValue(false));
			//set selected chapter as primary, this will inturn mark it selected as well
			this._setPrimary(id);
		}

	}

	changePrimary(event: MatRadioChange) {
		this._setPrimary(event.value);
	}

	_setPrimary(id?: any) {
		if (!id) {
			if (this.chapterDetails.chapters.length == 1) {
				this.chapterDetails.chapters[0].isPrimary = true;
				this.chapterDetails.chapters[0].selected = true;
			}

			let _c = this.chapterDetails.chapters.filter(a => a.isPrimary)[0];
			if (_c) {
				id = _c.id;
			}
		}

		this.chapterFormArray.controls.forEach(ctrl => {
			ctrl.get("isPrimary").setValue(ctrl.get("id").value == id);
		});

		//Mark Primary as Selected
		if (id) {
			this.chapterFormArray.controls
				.filter(ctrl => ctrl.get("id").value == id)[0]
				.get("selected")
				.setValue(true);
		}
	}

	chapterChange() {
		this.memberAppDataService.navigateToRoute("changeaddress");
	}

	prepareDataModel(): ChapterDetails {
		let p: ChapterDetails = Object.assign(
			{},
			this.chapterDetails,
			this.chapterForm.value
		) as ChapterDetails;
		return p;
	}

	save() {
		super.onSave(this.chapterForm);

		this.chapterDetails = this.prepareDataModel();
		if (this.chapterDetails.chapters.filter(a => a.selected).length == 0) {
			this.globalDomOpsService.notify(
				"Please select a Primary Chapter",
				"",
				"warning"
			);
			return;
		}

		this.onSaveComplete();
	}

	onSaveComplete() {
		if (this.dataService.IsFromGroupPortal) {
			//save to the database if GP Mode

			this.subscriptions.push(this.chaptersService.saveChapterMemberships(this.chapterDetails).subscribe((d) => {
				this.globalDomOpsService.notify("Chapter Information Updated");
				//take the use to receipt page
				this.memberAppDataService.notify(
					this.memberAppDataService.memberAppData.profile.membership
						.IsOnAutoRenewal
						? NotificationStatus.RenewalSuccesful
						: NotificationStatus.NewMembershipSuccessful
				);

			}));
		}
		else {
			this.memberAppDataService.memberAppData.chapterDetails = this.chapterDetails;
			this.globalDomOpsService.notify("Chapter Information Updated");
			this.memberAppDataService.navigateToRoute("sections");
		}
	}
}
